import { AppId } from '@wix/cashier-common/dist/src/enums/AppId';

export const getAppNameById = (appId: AppId | string): string =>
  Object.keys(AppId).find((key) => AppId[key] === appId);
